import { Icons } from "assets/svgs";

export const PageSearchInput = ({
  className = "w-[250px]",
  inputClassName = "",
  placeholder,
  value,
  children,
  onSearch,
  onClear,
  ...rest
}) => (
  <div className={`relative ${className}`}>
    <input
      className={`h-9 w-full rounded-md border border-gray-300 pl-8 pr-8 text-ui-md outline-none transition-colors focus:border-[#437f55] ${inputClassName}`}
      data-search-input=""
      placeholder={placeholder}
      value={value}
      onChange={(event) => onSearch(event.target.value)}
      {...rest}
    />

    <Icons.SearchIcon className="absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2" fill="#9CA3AF" />

    {onClear && value ? (
      <button
        className="absolute right-2 top-1/2 -translate-y-1/2 text-[#437f55] transition-colors hover:text-[#356a45]"
        title="Clear"
        type="button"
        onClick={onClear}
        onMouseDown={(event) => event.preventDefault()}
      >
        <Icons.FaXmarkIcon className="h-3 w-3" />
      </button>
    ) : (
      <kbd className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md border border-gray-200 px-1 text-ui-2xs text-gray-400">
        /
      </kbd>
    )}

    {children}
  </div>
);
